import tableClass from "../../Table/Table.module.css";
import employeeClasses from "../../Employee/AddEmployeeDirectory/AddEmployeeDirectory.module.css";
import companyClasses from "../../Company/AddNewCompany/AddNewCompany.module.css";
import classes from "../../Employee/AddEmployeeDirectory/AddEmployeeDirectory.module.css";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useContext, useState } from "react";
import authContext from "../../../../AuthContext/authContext";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from 'react-modal';
import ManagersTable from '../ManagersTable/ManagersTable';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');
const base_url = process.env.REACT_APP_BASE_URL;
const EditLocation = ({ initialData , onSuccess }) => {
  const editType = useSelector((state) => state.appData.activeEditType);
  const [IsDisabled, setIsDisabled] = useState(false);
  const [managers, setManagers] = useState(
    initialData.managers && initialData.managers.length > 0
      ? initialData.managers.map((manager, index) => ({
          id: manager._id || `new-${index}`,
          name: manager.name || "",
          email: manager.email || "",
          phone: manager.phone || "",
          user_type: manager.user_type || "",
          password: "",
          _id: manager._id
        }))
      : []
  );
  const ctx = useContext(authContext);
  const user_type = ctx.userData.user_type;
  console.log(user_type,"user_type");
  const token = ctx.token;
  const showIcons = editType !== "Company";
  const user_id = ctx.userData.user_id;
  const activeEditLocationId = useSelector(
    (state) => state.appData.activeEditLocationId
  );
  const activeEditCompanyId = useSelector(
    (state) => state.appData.activeCompany._id
  );
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const nameRegExp = /^[A-Za-z ]+$/;
  const locationRegExp = /^(?=.*[a-zA-Z])[a-zA-Z0-9\s\S]*$/;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [managerToDelete, setManagerToDelete] = useState(null);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      location: initialData.location,
      managers: managers.length > 0 ? managers : [{ name: "", email: "", phone: "", password: "", _id: "" }],
    },
    validationSchema: Yup.object({
      location: Yup.string()
        .matches(locationRegExp, "Location cannot be a number")
        .required("Please enter company location"),
      managers: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .matches(nameRegExp, "Please enter valid name")
            .required("Please enter company manager name"),
          email: Yup.string()
            .email("Invalid email address")
            .required("Please enter email address"),
          phone: Yup.string()
            .matches(phoneRegExp, "Phone number is not valid")
            .length(10, "Phone number should be of 10 digits")
            .required("Please enter your phone number"),
          password: Yup.string()
            .when('_id', {
              is: (id) => !id, // Only validate password if _id doesn't exist (new manager)
              then: (schema) => schema
                .min(8, "Password must be at least 8 characters long")
                .required("Password is required for new managers"),
              otherwise: (schema) => schema.notRequired()
            })
        })
      ),
    }),
    onSubmit: (values) => {
      if (managers.length > 2) {
        toast.warning("Maximum of 2 managers allowed per company");
        return;
      }
      setIsDisabled(true);
      const dataObj = {
        location: values.location,
        companyId: activeEditCompanyId,
        user_type: user_type,
        managers: managers.map(manager => ({
          name: manager.name,
          email: manager.email,
          phone: manager.phone,
          password: manager.password || "",
          _id: manager._id,
        })),
        userId: initialData._id,
      };

      let reqObj = {
        method: "PUT",
        url: `${base_url}/user/locationManager/${activeEditLocationId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${ctx.token}`,
        },
        data: dataObj,
      };

      axios(reqObj)
        .then((res) => {
          toast.dismiss();
          toast.success(`${editType} updated successfully`);
          setIsDisabled(false);
          onSuccess();
        })
        .catch((err) => {
          console.log(err);
          toast.dismiss();
          toast.error(
            err.response.data.error.message || `Failed to update ${editType}`
          );
          setIsDisabled(false);
        });
    },
  });
  console.log(managers, "managers");
  const addManager = () => {
    const newManager = {
      name: "",
      email: "",
      phone: "",
      password: "",
      _id: `temp-${Date.now()}` // Add a temporary ID for new managers
    };
    setManagers([...managers, newManager]);
  };

  const handleDeleteConfirm = async () => {
    if (managerToDelete === null) return;

    const { index, manager } = managerToDelete;
    const newManagers = [...managers];
    newManagers.splice(index, 1);

    // Check if manager exists in initial data (has an _id)
    if (manager._id) {
      try {
        const deleteReqObj = {
          method: "DELETE",
          url: `${base_url}/user/locationManager/${manager._id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${ctx.token}`,
          },
        };

        await axios(deleteReqObj);
        setManagers(newManagers); // Only update state after successful API call
        toast.success("Manager deleted successfully");
      } catch (err) {
        console.log(err);
        toast.error(err.response?.data?.error?.message || "Failed to delete manager");
      }
    } else {
      // For new managers not yet saved to the server, just update the state
      setManagers(newManagers);
    }

    // Reset the modal state
    setShowDeleteModal(false);
    setManagerToDelete(null);
  };

  const removeManager = (index) => {
    setManagerToDelete({ index, manager: managers[index] });
    setShowDeleteModal(true);
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setManagerToDelete(null);
  };

  const handleManagerChange = (index, field, value) => {
    const newManagers = [...managers];
    // Preserve the _id field when updating manager data
    newManagers[index] = {
      ...newManagers[index],
      [field]: value,
      // Ensure _id is preserved if it exists, or set a temporary one if it's a new manager
      _id: newManagers[index]._id || `temp-${Date.now()}`
    };
    setManagers(newManagers);

    // Also update the Formik form values to keep them in sync
    formik.setFieldValue(`managers[${index}].${field}`, value);
  };

  return (
    <div>
      <div className={classes.mainCont}>
        <h3>{`Edit ${editType}`}</h3>
        <div className={classes.topLinks}>
          {showIcons && (
            <div className={tableClass.tableAction}>
              <Link to="/employeeDirectory">
                <img
                  src={require("../../../../assets/img/admin-images/copy.png")}
                />
                <span>Employee Directory</span>
              </Link>
            </div>
          )}
          {showIcons && (
            <div className={tableClass.tableAction}>
              <Link to="/location">
                <img
                  src={require("../../../../assets/img/admin-images/company_logo.png")}
                />
                <span>Location</span>
              </Link>
            </div>
          )}
        </div>

        <form className={classes.FormDiv} onSubmit={formik.handleSubmit}>
          <div className={classes.formGrp}>
            <label for="location">{`${editType} Name:`}</label>
            <div>
              <input
                type="text"
                id="location"
                name="location"
                {...formik.getFieldProps("location")}
              />
              <span className={classes.profileerrMsg}>
                {formik.touched.location && formik.errors.location ? (
                  <div>{formik.errors.location}</div>
                ) : null}
              </span>
            </div>
          </div>
          <div className={classes.managersSection}>
            <h4>Company Managers</h4>
            <ManagersTable
              managers={managers}
              setManagers={setManagers}
              formik={formik}
              handleManagerChange={handleManagerChange}
              token={token}
              base_url={base_url}
            />
          </div>

          <div className={classes.formBtn}>
            <button
              type="submit"
              className={classes.createBtn}
              disabled={IsDisabled}
            >
              Update
            </button>
          </div>
        </form>
      </div>

      <Modal
        isOpen={showDeleteModal}
        onRequestClose={handleDeleteCancel}
        contentLabel="Delete Manager Confirmation"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '400px',
            width: '90%',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
          }
        }}
      >
        <h2 style={{ marginTop: 0 }}>Delete Manager</h2>
        <p>Are you sure you want to delete this manager?</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <button
            onClick={handleDeleteCancel}
            style={{
              padding: '8px 16px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              background: 'white',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleDeleteConfirm}
            style={{
              padding: '8px 16px',
              border: '1px solid #dc3545',
              borderRadius: '4px',
              background: '#dc3545',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            Delete
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default EditLocation;
